import { useEffect, useRef } from "react";
import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom-v5-compat";

import { Modal } from "@seneca/senekit";

import { hasLiveSubscription } from "seneca-common/features/subscriptions/state";
import { subscriptionsFetchSucceeded } from "seneca-common/features/subscriptions/state/selectors/state/subscriptions/meta";
import {
  useSimpleNavigationCallback,
  useSimpleRedirectCallback
} from "seneca-common/utils/hooks/routing";
import useSelectorOnCondition from "seneca-common/utils/hooks/selectors/useSelectorOnCondition";
import { useTypedState } from "seneca-common/utils/routing/react-router-typesafe-routes/dom";

import { ModalPortal } from "features/common/modals/components/ModalNodeContext";
import { MODAL_ROUTES, ROUTES } from "routing/routes";

import ModalPages from "./ModalPages";

export default function TransferSubscriptionModal() {
  const { background } = useTypedState(MODAL_ROUTES.TRANSFER_SUBSCRIPTION);
  const { redirectToMonitoringOverviewPage } =
    useTransferSubscriptionRedirects();

  const closeModal = useSimpleNavigationCallback(background);

  if (!background) {
    return (
      <Navigate to={ROUTES.PARENT.SETTINGS.PREMIUM.buildPath({})} replace />
    );
  }

  return (
    <ModalPortal>
      <Modal fullscreenOnMobile onCloseClick={closeModal}>
        <ModalPages onEndSessionClick={redirectToMonitoringOverviewPage} />
      </Modal>
    </ModalPortal>
  );
}

function useTransferSubscriptionRedirects() {
  const userSubscriptionsFetched = useSelector(subscriptionsFetchSucceeded);

  const redirectToPremiumSettings = useSimpleRedirectCallback(
    ROUTES.PARENT.SETTINGS.PREMIUM.buildPath({})
  );
  const redirectToMonitoringOverviewPage = useSimpleRedirectCallback(
    ROUTES.PARENT.MONITORING.buildPath({})
  );

  const userHasSubscription = useSelectorOnCondition(
    userSubscriptionsFetched,
    hasLiveSubscription
  );

  const hasRunEffectAfterFetch = useRef(false);
  useEffect(() => {
    if (userSubscriptionsFetched) {
      if (!userHasSubscription && !hasRunEffectAfterFetch.current) {
        redirectToPremiumSettings();
      }

      hasRunEffectAfterFetch.current = true;
    }
  }, [
    userSubscriptionsFetched,
    userHasSubscription,
    redirectToPremiumSettings
  ]);

  return { redirectToMonitoringOverviewPage };
}
